import { timer } from '@app/assets/images'
import { APP_ROUTES } from '@app/constants'
import React, { useRef } from 'react'
import Countdown from 'react-countdown'
import { useNavigate } from 'react-router-dom'

interface Props {
  translate: (key: string) => string
  language: string
}

const Timer: React.FC<Props> = ({ translate, language }) => {
  const navigate = useNavigate()
  const endTimeRef = useRef(Date.now() + 2 * 60 * 1000)

  const isRussian = language.trim().toLowerCase().startsWith('ru')

  return (
    <div className='h-full  flex flex-col bg-rgba(197, 119, 186, 0.2) px-4 py-6 text-base md:text-lg lg:text-xl'>
      <header className='text-center mb-4 flex-shrink-0'>
        <h1 className='text-xl md:text-2xl lg:text-3xl font-semibold mt-2 leading-tight'>
          {translate('tutorial.timer_screen.heading')}
        </h1>
      </header>

      <main className='flex-1  flex justify-center items-center overflow-hidden'>
        <section className='w-full max-w-sm md:max-w-md lg:max-w-lg flex flex-col bg-white rounded-xl shadow-md border p-4 md:p-6 mx-auto h-full sm:h-auto'>
          {/* Countdown */}
          <div className='text-5xl md:text-5xl lg:text-6xl font-bold text-gray-800 text-center mt-10 md:mt-6 flex-shrink-0'>
            <Countdown
              onComplete={() => navigate(APP_ROUTES.measure_vitals)}
              date={endTimeRef.current}
              renderer={({ minutes, seconds, completed }) =>
                completed ? '00:00' : `${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`
              }
            />
          </div>

          {/* Illustration */}
          <div className='flex-1 flex justify-center items-center min-h-0'>
            <img src={timer} alt='Hold phone at eye level' className='max-w-[80%] max-h-[80%] object-contain my-4' />
          </div>

          {/* Instructions */}
          <div
            className={`${
              isRussian ? 'text-[10px] md:text-sm lg:text-base leading-tight' : 'text-sm md:text-base lg:text-lg'
            } text-center text-gray-500 font-semibold mb-6 flex-shrink-0`}
          >
            {translate('tutorial.timer_screen.para1')}
            <p className='mt-2'>{translate('tutorial.timer_screen.para2')}</p>
          </div>
        </section>
      </main>

      {/* Footer Button */}
      <footer className='w-full max-w-sm md:max-w-md lg:max-w-lg mx-auto mt-4 flex-shrink-0'>
        <button
          type='button'
          onClick={() => navigate(APP_ROUTES.measure_vitals)}
          className='w-full py-2 md:py-3 rounded-lg font-medium transition-colors duration-200 
            bg-blue-600 text-white hover:bg-blue-700 focus:ring-2 focus:ring-blue-400 text-base md:text-lg lg:text-xl'
        >
          {translate('tutorial.timer_screen.btn_text')}
        </button>
      </footer>
    </div>
  )
}

export default Timer
